// const FieldError = ({ name, touched, errors, msg }) => {
//   return (
//     <>
//       {errors[name] && touched[name] && <div className="input_error_msg">{errors[name]}</div>}
//     </>
//   )
// }

import { ErrorMessage } from 'formik'
// the render callback will only be called when the
// field has been touched and an error exists and subsequent updates.
const FieldError = ({ name }) => {
  return (
    <ErrorMessage name={name} render={(msg) => <div className="input_error_msg">{msg}</div>} />
  )
}

export default FieldError
